export default __webpack_public_path__ + "static/media/check-black.b6232326.svg";